import { useRef, useState } from 'react'

/**
 * Hook para calcular a largura do Popover
 * */
export const usePopoverWidth = (defaultWidth: number = 418) => {
  const [popoverWidth, setPopoverWidth] = useState(defaultWidth)
  const containerRef = useRef<HTMLDivElement>(null)

  const updateWidth = () => {
    const width = containerRef?.current?.getBoundingClientRect()?.width
    setPopoverWidth(width || defaultWidth)
  }

  return { popoverWidth, containerRef, updateWidth }
}
